import React from "react";
import { MdOutlineMail } from "react-icons/md";
import { BsTelephone } from "react-icons/bs";
import { Avatar, Badge } from "antd";

export default function Profile({ userData }) {
  return (
    <>
      <div className="chat-header-main">
        <div className="chat-user-image">
          <Badge
            color={userData?.IsOnline ? "#118936" : "#9e9e9e"}
            className="ProfileAvatar"
            dot={true}
            offset={[-5, 35]}
          >
            <Avatar
              size={40}
              src={`${process.env.REACT_APP_S3_URL}/${userData?.Profiles?.PictureUrl}`}
              className={"avatarBgColor"}
            >
              {userData?.Profiles?.FirstName?.slice(0, 1)?.toUpperCase()}
            </Avatar>
          </Badge>
        </div>
        <div className="username-chat-status">
          <div className="username-chat">
            {userData?.Profiles?.FirstName
              ? `${userData?.Profiles?.FirstName} ${userData?.Profiles?.LastName}`
              : "NA"}
          </div>
          <div className="userstatus-chat">
            {userData?.IsOnline ? "Online" : "Offline"}
          </div>
        </div>
      </div>
      <div className="email-phone-chat">
        <MdOutlineMail style={{ fontSize: "0.875rem", color: "#7E7E7E" }} />{" "}
        <div
          onClick={(e) => {
            window.location.href = `mailto:${userData?.EmailAddress}` || `#!`;
          }}
          className="email-chat"
        >
          {userData?.EmailAddress ? userData?.EmailAddress : "NA"}
        </div>
        <BsTelephone style={{ fontSize: "0.875rem", color: "#7E7E7E" }} />{" "}
        <div className="phonenumber-chat">
          {userData?.Profiles?.MobilePhone || "NA"}
        </div>
      </div>
    </>
  );
}
